import { Box, Divider, Grid, Typography } from '@mui/material';
import currency from 'currency.js';
import { useWatch } from 'react-hook-form';

import BillLineItems from './BillLineItems';

import { useBillFormContext } from '../BillFormContext';

const BillLineItemsSection = () => {
  const {
    headerForm: { control },
    total,
  } = useBillFormContext();

  const amount = useWatch({ name: 'amount', control }) || 0;
  const remaining = amount - total;

  return (
    <>
      <Divider>Bill Line Items</Divider>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          mb: 2,
        }}
      >
        <Typography variant="subtitle1">
          <Grid container>
            <Grid sx={{ px: 1 }}>Bill Amount: {currency(amount).format()}</Grid>
            <Divider orientation="vertical" flexItem />
            <Grid sx={{ px: 1 }}>
              Remaining: {currency(remaining).format()}
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid sx={{ px: 1 }}>
              Line Item Total: {currency(total).format()}
            </Grid>
          </Grid>
        </Typography>
      </Box>
      <BillLineItems />
    </>
  );
};

export default BillLineItemsSection;
